import { useProduct } from './useProduct';
import { useAnalytics } from './useAnalytics';

export function useRedirectManager() {
    const { product, ProductType } = useProduct();
    const { logNavigatedTo } = useAnalytics();

    const loginUrl = () => {
        const accountsUrl = ProductType.Accounts.url || window.location.origin;
        return `${accountsUrl}/login`;
    };

    const redirectToAccountsLogin = () => {
        const url = `${loginUrl()}?continue=${product.value.name}`;
        window.location = url;
    };

    const redirectToAccounts = (route) => {
        return redirectToProduct(ProductType.Accounts, route);
    };

    const redirectToStore = (route) => {
        return redirectToProduct(ProductType.Store, route);
    };

    const redirectToWeb = (route) => {
        return redirectToProduct(ProductType.Web, route);
    };

    const redirectToProduct = (toProduct, route) => {
        logNavigatedTo(toProduct.name);
        const url = route ? `${toProduct.url}/${route}` : toProduct.url;
        return window.open(url, '_blank');
    };

    return {
        redirectToAccountsLogin,
        redirectToAccounts,
        redirectToStore,
        redirectToWeb,
    };
}
